import React, {Component} from "react";
import {Doughnut,Radar, Polar, Pie} from 'react-chartjs-2';

class RenderChartSatuan extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }


    renderChart(){
        const val = this.props.value;
        let perbandinganProsentase = (val * 360) /100;
        let data = [perbandinganProsentase, (360 - perbandinganProsentase)];
        let label = ['', ''];
    
        return(
            <Doughnut
                data={{
                    labels: label,
                    datasets: [{
                        data: data,
                        backgroundColor: [
                            ''+this.props.color,
                            '#BDBDBD'
                        ] ,
                        width: 1
                    }]
                }}
                options = {{  
                    legend: {
                        display: false
                    },
                    plugins: {
                        datalabels: {
                          display: false
                        },
                        outlabels: {
                          display: false
                        }
                      }    
                }}
            />
        )
    }


    render() { 
        return (
            this.renderChart()
        );
    }
}
 
export default RenderChartSatuan;